import { render, staticRenderFns } from "./PraticaTrasportoPrincipaleMare.vue?vue&type=template&id=00b3369f&scoped=true&"
import script from "./PraticaTrasportoPrincipaleMare.vue?vue&type=script&lang=js&"
export * from "./PraticaTrasportoPrincipaleMare.vue?vue&type=script&lang=js&"
import style0 from "./PraticaTrasportoPrincipaleMare.vue?vue&type=style&index=0&id=00b3369f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b3369f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b3369f')) {
      api.createRecord('00b3369f', component.options)
    } else {
      api.reload('00b3369f', component.options)
    }
    module.hot.accept("./PraticaTrasportoPrincipaleMare.vue?vue&type=template&id=00b3369f&scoped=true&", function () {
      api.rerender('00b3369f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaTrasportoPrincipaleMare.vue"
export default component.exports